class HeaderMegaMenu extends HTMLElement {
  constructor() {
    super();
    this._leaveTimer = null;
  }

  connectedCallback() {
    this.trigger = this.querySelector('.mega-menu__trigger');
    this.headerWrapper = document.querySelector('.header-wrapper');

    this.addEventListener('mouseenter', this.onPointerEnter.bind(this));
    this.addEventListener('mouseleave', this.onPointerLeave.bind(this));
    this.addEventListener('focusin', this.onFocusIn.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.trigger?.addEventListener('click', this.onTriggerClick.bind(this));

    requestAnimationFrame(() => this.setHeaderBottomVar());
  }

  onTriggerClick(event) {
    const href = this.trigger?.getAttribute('href')?.trim();
    if (!href || href === '#' || href === '#top') {
      event.preventDefault();
    }
  }

  setHeaderPreventHide(active) {
    const wrap = this.headerWrapper || document.querySelector('.header-wrapper');
    if (wrap) wrap.preventHide = active;
  }

  onPointerEnter() {
    if (this._leaveTimer) {
      clearTimeout(this._leaveTimer);
      this._leaveTimer = null;
    }
    this.classList.add('mega-menu--interacting');
    this.closeOtherMegas();
    this.removeAttribute('data-force-closed');
    this.setExpanded(true);
    this.setHeaderPreventHide(true);
    this.setHeaderBottomVar();
  }

  closeOtherMegas() {
    document.querySelectorAll('header-mega-menu').forEach((host) => {
      if (host !== this) host.close();
    });
  }

  onPointerLeave() {
    if (this._leaveTimer) clearTimeout(this._leaveTimer);
    this._leaveTimer = setTimeout(() => {
      this._leaveTimer = null;
      if (!this.matches(':hover') && !this.contains(document.activeElement)) {
        this.classList.remove('mega-menu--interacting');
        this.setExpanded(false);
        this.setHeaderPreventHide(false);
      }
    }, 200);
  }

  onFocusIn() {
    if (this._leaveTimer) {
      clearTimeout(this._leaveTimer);
      this._leaveTimer = null;
    }
    this.classList.add('mega-menu--interacting');
    this.closeOtherMegas();
    this.removeAttribute('data-force-closed');
    this.setExpanded(true);
    this.setHeaderPreventHide(true);
    this.setHeaderBottomVar();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.classList.remove('mega-menu--interacting');
        this.setExpanded(false);
        this.setHeaderPreventHide(false);
      }
    });
  }

  setExpanded(open) {
    if (!this.trigger) return;
    this.trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  setHeaderBottomVar() {
    const wrap = this.headerWrapper || document.querySelector('.header-wrapper');
    if (!wrap) return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(wrap.getBoundingClientRect().bottom)}px`
    );
  }

  close() {
    if (this._leaveTimer) {
      clearTimeout(this._leaveTimer);
      this._leaveTimer = null;
    }
    this.classList.remove('mega-menu--interacting');
    this.setAttribute('data-force-closed', '');
    this.setExpanded(false);
    this.setHeaderPreventHide(false);
  }
}

customElements.define('header-mega-menu', HeaderMegaMenu);
